import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'

export default {
  props: ['type', 'role'],
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error(
            'Takeoff grouping must be less than or equals to 100 characters',
          ),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'takeoffGrouping',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      takeoffGroupingList: [],
      form: {
        id: undefined,
        option: '',
        isActive: 1,
      },
      rules: {
        option: [
          {
            required: true,
            message: 'Please enter takeoff grouping',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      isRefresh: this.refresh,
      height: '250px',
      filters: {},
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteTakeoffGrouping', this.deleteTakeoffGrouping)
    this.$root.$on('editTakeoffGrouping', this.getTakeoffGroupingById)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$on('loadTakeoffGroupings', this.loadTakeoffGroupings)
  },
  beforeDestroy() {
    this.$root.$off('deleteTakeoffGrouping')
    this.$root.$off('editTakeoffGrouping')
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('loadTakeoffGroupings')
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.columnDefs = gridProperties.master.columns.takeoffGrouping
    },

    // Refresh Takeoff Groupings
    refreshTakeoffGroupings() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.takeoffGroupingList = []
      this.page = 0
      this.defaultSortedBy = 'takeoffGrouping'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'takeoffGrouping',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.isRefresh = true
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTakeoffGroupings(this.gridOptions)
    },

    // Delete Takeoff Grouping
    deleteTakeoffGrouping(record) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${record.option}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this takeoff
              grouping
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Save Takeoff Grouping
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = ''
          const req = {
            takeoffGrouping: this.form.option,
          }
          let method = 'put'
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.takeoffGrouping.details(this.form.id)
          } else {
            method = 'post'
            url = masterAPIs.takeoffGrouping.add
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id
                  ? 'Update Takeoff Grouping'
                  : 'Create Takeoff Grouping',
                this.form.id
                  ? 'Takeoff Grouping updated successfully!'
                  : 'Takeoff Grouping created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.takeoffGroupingList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.form.id = null
                this.takeoffGroupingList = newData
              } else {
                this.getTakeoffGroupings(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
              this.$emit('loadTakeoffGroupings')
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Get Takeoff Groupings
    getTakeoffGroupings(params, type) {
      params.api.sizeColumnsToFit()
      this.tableParams = null
      this.tableParams = params
      const data = params.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = params.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      const url = masterAPIs.takeoffGrouping.list
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        takeoffGrouping: _.get(this.filters, 'takeoffGrouping', undefined),
      }
      instance
        .post(url, req)
        .then(response => {
          this.takeoffGroupingList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'takeoffGroupingTable',
            this.count > this.pageSize,
          )
          this.loading = false
          const searchText = _.get(this.filters, 'option', undefined)
          if (!searchText) {
            this.$emit(
              'getGroupings',
              this.takeoffGroupingList,
              this.count,
              this.height,
            )
          }
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      const url = masterAPIs.takeoffGrouping.delete
      instance
        .patch(url, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Takeoff Grouping',
            'Takeoff Grouping deleted successfully!',
          )
          this.refreshTakeoffGroupings()
          this.$emit('loadTakeoffGroupings')
        })
        .catch(error => {
          this.loading = false
          this.$notification.open({
            message: 'Delete Takeoff Grouping',
            description: error.response.data.Message,
            icon: <a-icon type="warning" style="color: #fb434a" />,
          })
        })
    },

    cancel() {
      this.form.id = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Delete All Takeoff Groupings
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoff groupings ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              takeoff groupings
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.isRefresh = true
      this.takeoffGroupingList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = 'takeoffGrouping'
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'takeoffGrouping'
        this.defaultSortOrder = true
      }
      this.getTakeoffGroupings(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getTakeoffGroupingById(id) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.spinner = true
      const url = masterAPIs.takeoffGrouping.details(id)
      instance
        .get(url)
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          if (this.type !== 'Template') {
            this.form['option'] = _.get(
              response.data,
              'result.takeoffGrouping',
              null,
            )
          }
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'takeoffGroupingTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.takeoffGroupingList = []
      this.selectedRowKeys = []
      this.getTakeoffGroupings(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.takeoffGroupingList = []
      this.loading = true
      this.page = 0
      this.getTakeoffGroupings(this.gridOptions)
    },

    loadTakeoffGroupings(flag) {
      if (flag) {
        this.$emit('loadTakeoffGroupings')
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.takeoffGrouping,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.takeoffGrouping))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getTakeoffGroupings(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'takeoffGrouping'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'takeoffGrouping',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
